module.exports = __webpack_public_path__ + "static/img/IMG_20160101_161926-ANIMATION.85d1da9b.gif";